import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import {
  parseReportingRunDetail,
  type ReportingRunDetail,
} from "./parseReportingRuns";
import { buildReportingRunPath } from "./reportingPaths";

export const REPORTING_RUN_QUERY_KEY = [
  "regulator-portal",
  "reporting-run",
] as const;

export const reportingRunQueryKey = (runId: string) =>
  [...REPORTING_RUN_QUERY_KEY, runId] as const;

export const fetchReportingRun = async (
  runId: string,
): Promise<ReportingRunDetail | null> => {
  const response = await createRegulatorPortalInstance().get(
    buildReportingRunPath(runId),
  );
  return parseReportingRunDetail(response.data);
};

export const useReportingRun = (
  runId?: string,
): UseQueryResult<ReportingRunDetail | null, Error> =>
  useQuery<ReportingRunDetail | null, Error>({
    queryKey: reportingRunQueryKey(runId ?? ""),
    queryFn: () => fetchReportingRun(runId ?? ""),
    enabled: Boolean(runId),
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
    retry: false,
  });
